<div class="filter-group">
  <div class="filter-group__header">
    <div class="filter-group__title">
      {{ 'filters.roomCount.label' | i18n }}
    </div>

    <button class="filter-group__reset" *ngIf="canReset" (click)="reset()">
      {{ 'filters.common.reset' | i18n }}
    </button>
  </div>

  <div class="filter-group__main">
    <div class="rooms-filter">
      <div class="rooms-filter__dropdown rooms-filter__dropdown--min">
        <lib-standard-dropdown
          [options]="options"
          [currentOption]="currentFilter.min"
          [defaultOption]="defaultMinOption"
          (update)="onMinChange($event)"
        ></lib-standard-dropdown>
      </div>

      <span class="rooms-filter__text">
        {{ 'filters.roomCount.to' | i18n }}
      </span>

      <div class="rooms-filter__dropdown rooms-filter__dropdown--max">
        <lib-standard-dropdown
          [options]="options"
          [currentOption]="currentFilter.max"
          [defaultOption]="defaultMaxOption"
          (update)="onMaxChange($event)"
        ></lib-standard-dropdown>
      </div>
    </div>
  </div>
</div>
